module.exports = __webpack_public_path__ + "static/media/grid_screen_3.bc3a835b.jpg";